export interface LabelProps
  extends React.LabelHTMLAttributes<HTMLLabelElement> {
  isRequired?: boolean;
  className?: string;
  disabled?: boolean;
  tagName?: 'label' | 'div' | 'span';
}

const Label = ({
  isRequired = false,
  className = '',
  disabled = false,
  tagName = 'label',
  ...props
}: LabelProps) => {
  if (tagName === 'label') {
    return (
      <label
        className={`${className} flex items-center gap-1 text-sm text-black/64`}
        {...props}
      >
        {props.children}
        {isRequired && <span className="text-rose-500">*</span>}
      </label>
    );
  }
  const CustomTag = tagName;
  return (
    <CustomTag
      className={`${className} block text-xs font-medium leading-tight pb-1.5 ${
        disabled ? 'opacity-50' : ''
      }`}
    >
      {props.children}
      {isRequired && <span className="text-rose-500">*</span>}
    </CustomTag>
  );
};

export default Label;
